import { Route, Switch } from 'react-router-dom';

import AviatorCrushLanding from '../../components/aviator-crush';
import PageNotFound from '../../components/page-not-found';

// PF-8560: isolated Crush module, deletable as a unit post-event (D20). Do not add
// Crush-specific conditionals anywhere else in the shared router/components.
const AviatorCrushContainer = () => (
  <Switch>
    <Route exact path='/aviator-crush' component={AviatorCrushLanding} />
    <Route component={PageNotFound} />
  </Switch>
);

export default AviatorCrushContainer;
